export default {
      id: "ic_appli-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_appli-usage",
      toString: function () {
        return this.url;
      }
    }